<script setup lang="ts">
import { seaTurtleApiClauseInfoAgreementTypeListPost } from '@/services/api/CommonApi'
import { useCommonConfig } from '~/store/common'

const props = defineProps({
  path: {
    type: String,
    default: '',
  },
  categoryId: {
    type: [Number, String],
    default: 0,
  },
})

const commonConfig: any = useCommonConfig()

const { t } = useLang()
const { locale } = useI18n()
const router = useRouter()
const route = useRoute()

const clauseMenuMap: Record<number, { categoryId: string; nameKey: string; path: string; route: string }> = {
  4: {
    categoryId: commonConfig.commonRouteCategoryMap['about-us'],
    nameKey: 'company.b_left_company',
    path: 'about-us',
    route: '/common/about-us',
  },
  1: {
    categoryId: commonConfig.commonRouteCategoryMap['terms-and-conditions'],
    nameKey: 'termsservice.b_left_terms',
    path: 'terms-and-conditions',
    route: '/common/terms-and-conditions',
  },
  2: {
    categoryId: commonConfig.commonRouteCategoryMap['privacy-policy'],
    nameKey: 'privacypolicy.b_left_privacypolicy',
    path: 'privacy-policy',
    route: '/common/privacy-policy',
  },
  5: {
    categoryId: commonConfig.commonRouteCategoryMap['why-book-with-us'],
    nameKey: 'whybook.b_left_why',
    path: 'why-book-with-us',
    route: '/common/about-us/why-book-with-us',
  },
}

const menuList = ref<{
  agreementType: number
  categoryId: string
  name: string
  path: string
  route: string
}[]>([])

function getFullLink(route: string) {
  const { href } = router.resolve({
    path: `/${locale.value}${route}`,
  })
  return href
}

async function queryData() {
  try {
    const res = await seaTurtleApiClauseInfoAgreementTypeListPost({})

    menuList.value = Array.isArray(res)
      ? res.reduce<typeof menuList.value>((list, item) => {
        const agreementType = Number(item.agreementType)
        const menuConfig = clauseMenuMap[agreementType]

        if (menuConfig) {
          list.push({
            agreementType,
            categoryId: menuConfig.categoryId,
            name: t(menuConfig.nameKey),
            path: menuConfig.path,
            route: menuConfig.route,
          })
        }

        return list
      }, [])
      : []

    commonConfig.setCommonMenuList(menuList.value.map(item => ({
      categoryId: item.categoryId,
      name: item.name,
    })))
  }
  catch (error) {
    menuList.value = []
    commonConfig.setCommonMenuList([])
  }
}

function isActive(item: { categoryId: string; path: string; route: string }) {
  if (props.path) {
    return item.path === props.path
  }

  if (props.categoryId) {
    return `${item.categoryId}` === `${props.categoryId}`
  }

  return route.path === getFullLink(item.route)
}

onMounted(() => {
  setTimeout(() => {
    if (process.client) {
      queryData()
    }
  })
})
</script>

<template>
  <div v-if="menuList.length" class="left_nav">
    <ul>
      <li v-for="(item, index) in menuList" :key="index">
        <a
          :href="getFullLink(item.route)"
          :class="{ active: isActive(item) }"
        >{{
          item.name
        }}</a>
      </li>
      <!-- <li>
        <a :href="getFullLink('/common/about-us/how-we-started')" :class="{ active: props.path === 'how-we-started' }">{{
          t('howstart.b_left_how') }}</a>
      </li>
      <li>
        <a
          :href="getFullLink('/common/about-us/why-book-with-us')"
          :class="{ active: props.path === 'why-book-with-us' }"
        >{{
          t('whybook.b_left_why') }}</a>
      </li>
      <li>
        <a
          :href="getFullLink('/common/terms-and-conditions')"
          :class="{ active: props.path === 'terms-and-conditions' }"
        >{{
          t('termsservice.b_left_terms') }}</a>
      </li>
      <li>
        <a :href="getFullLink('/common/privacy-policy')" :class="{ active: props.path === 'privacy-policy' }">{{
          t('privacypolicy.b_left_privacypolicy') }}</a>
      </li> -->
    </ul>
  </div>
</template>

<style scoped lang="scss">
.left_nav {
  float: left;
  width: 215px;
  margin: 58px 0 0 35px;

  ul>li {
    padding-bottom: 28px;
    font-size: 18px;
    line-height: 18px;
    cursor: default;
  }

  a {
    text-decoration: none;
    color: #333;
    cursor: pointer;

    &:hover {
      color: var(--Brand-Green);
    }
  }

  .active {
    color: var(--Brand-Green);
    font-weight: 500;
  }
}
</style>
